import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { distinctUntilChanged, filter, map } from 'rxjs';
import { BoydRewardsService } from 'src/app/services/boyd-rewards/boyd-rewards.service';
import { EventsService } from 'src/app/services/event/event.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';

@Component({
  selector: 'app-rewards-card',
  templateUrl: './rewards-card.component.html',
  styleUrls: ['./rewards-card.component.scss'],
})
export class RewardsCardComponent implements OnInit {

  public isCardLinked: boolean = false;
  @Output() onCardClick: EventEmitter<any> = new EventEmitter();
  private userDetails = null

  constructor(private eventsService: EventsService,
    private boydRewardsService: BoydRewardsService,
    private userSessionService: UserSessionService,
  ) { }

  ngOnInit() {
    this.userSessionService.getCustomer().pipe(
      filter((userResponse) => !!userResponse),
      map(item => { return { lastName: item?.lastName, dob: item?.birthDate } }),
      distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr))
    ).subscribe((userResponse) => {
      this.userDetails = userResponse;
    })
    this.checkMenuOpenEvent();
  }

  toConnectCard() {
    this.onCardClick.emit({ page: 'RewardsConnectPage', params: this.userDetails });
  }

  toConvertPoints() {
    this.onCardClick.emit({ page: 'StarcardConvertPage', params: this.userDetails });
  }

  private checkMenuOpenEvent() {
    this.eventsService.subscribe('menuopen', () => {
      this.userSessionService.isAuthenticated().then(res => {
        if (res) {
          this.boydRewardsService.hasRewards().subscribe((res) => {
            if (res.payload) {
              this.isCardLinked = true;
            } else {
              this.isCardLinked = false;
            }
          });
        }
      });
    })
  }

}
